import React, { useState, useEffect } from "react";

const FilterDropdown = ({
    categories,
    messages,
    initialFilters,
    handleFilterChange,
}) => {
    const [selectedFilters, setSelectedFilters] = useState(initialFilters);

    // Handles the initialization of selected filters based on initialFilters and categories
    // This effect runs once on component mount
    useEffect(() => {
        if (
            initialFilters &&
            categories.length &&
            initialFilters.viewAll &&
            initialFilters.categories.length === 0
        ) {
            let obj = null;
            if (initialFilters.queryParamFilters.length > 0) {
                const categoryArray = initialFilters.queryParamFilters.map((categoryName) => {
                    return categories.find((cat) => cat.event_category_name.toLowerCase() === categoryName.toLowerCase());
                }).filter(Boolean);
                obj = {
                    viewAll: false,
                    categories: [...categoryArray],
                };
            } else {
                obj = {
                    viewAll: true,
                    categories: [...categories],
                };
            }
            
            setSelectedFilters(obj);
            handleFilterChange(obj);
        }
    }, []);

    // Handles checkbox change for a filter category or "viewAll"
    // event: The event triggered by the checkbox change
    // category: The category object or "viewAll" to toggle
    const handleCheckboxChange = (event, category) => {
        if (category === "viewAll") {
            const obj = {
                viewAll: !selectedFilters.viewAll,
                categories: selectedFilters.viewAll ? [] : categories,
            };
            setSelectedFilters(obj);
            handleFilterChange(obj);
        } else {
            const newCategories = selectedFilters.categories.some(
                (cat) => cat.event_category_name === category.event_category_name,
            )
                ? selectedFilters.categories.filter((item) => item.event_category_name !== category.event_category_name)
                : [...selectedFilters.categories, category];
            const obj = {
                ...selectedFilters,
                categories: newCategories,
                viewAll: false,
            };
            setSelectedFilters(obj);
            handleFilterChange(obj);
        }
    };

    // Clears all selected filters and resets to default state
    const handleClearAll = () => {
        const obj = {
            viewAll: false,
            categories: [],
        };
        setSelectedFilters(obj);
        handleFilterChange(obj);
    };

    const selectedCategoryNames = selectedFilters.categories
        .map((cat) => cat.event_category_localized_name)
        .join(", ");

    return (
			<div className="dropdown filter-dropdown oec-filter-dropdown">
				<button
					className="dropdown-toggle filter-dropdown__toggle"
					type="button"
					id="featuredOecFilter"
					data-bs-toggle="dropdown"
					aria-expanded="false"
					data-bs-auto-close="outside"
				>
					<span className="text-sort">{messages.filterBy}: </span>
					<span className="text-filters">
						{selectedFilters.viewAll ? messages.viewAll : selectedCategoryNames}
					</span>
					<span className="icon-arrowdown">
						<ion-icon name="chevron-down-outline"></ion-icon>
					</span>
					<span className="icon-swap">
						<ion-icon name="swap-vertical-outline"></ion-icon>
					</span>
				</button>
				<ul
					className="dropdown-menu dropdown-menu-sm-end"
					aria-labelledby="featuredOecFilter"
				>
					<li key="viewAll">
						<div className="form-options">
							<label className="form-options__checkbox">
								<input
									type="checkbox"
									name="sorting"
									value="viewAll"
									checked={selectedFilters.viewAll}
									onChange={() => handleCheckboxChange(null, "viewAll")}
								/>
								<span className="form-options__text">{messages.viewAll}</span>
							</label>
						</div>
					</li>

					{categories?.map((category, index) => (
						<li key={`${category.event_category_name}-${index}`}>
							<div className="form-options">
								<label className="form-options__checkbox">
									<input
										type="checkbox"
										name="category"
										value={category.event_category_name}
										checked={selectedFilters.categories.some(
											(cat) =>
												cat.event_category_name ===
												category.event_category_name,
										)}
										onChange={() => handleCheckboxChange(null, category)}
									/>
									<span
										className="form-options__icon"
										style={{
											color: category.event_color,
											fill: category.event_color,
										}}
									>
										<svg
											width="24"
											height="24"
											viewBox="0 0 24 24"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M19.5355 4.47142C19.3875 4.32165 19.2111 4.20284 19.0167 4.12191C18.8222 4.04097 18.6136 3.99953 18.4031 4H14.0128C13.7248 4.00054 13.4487 4.11462 13.2442 4.3175L4.46768 13.0923C4.1682 13.3924 4.00001 13.799 4.00001 14.223C4.00001 14.6469 4.1682 15.0536 4.46768 15.3537L8.64615 19.5321C8.94631 19.8317 9.35309 20 9.77719 20C10.2013 20 10.6081 19.8317 10.9082 19.5321L19.6812 10.7609C19.8845 10.5568 19.999 10.2808 19.9998 9.99271V5.59996C20.0011 5.39047 19.9607 5.18281 19.881 4.98906C19.8013 4.79531 19.6839 4.61936 19.5355 4.47142ZM16.5713 8.57132C16.3453 8.57132 16.1243 8.50429 15.9364 8.37872C15.7484 8.25314 15.602 8.07466 15.5155 7.86583C15.429 7.65701 15.4063 7.42722 15.4504 7.20554C15.4945 6.98385 15.6034 6.78022 15.7632 6.62039C15.923 6.46056 16.1267 6.35172 16.3484 6.30762C16.57 6.26352 16.7998 6.28616 17.0087 6.37265C17.2175 6.45915 17.396 6.60563 17.5215 6.79357C17.6471 6.98151 17.7141 7.20246 17.7141 7.42849C17.7141 7.73159 17.5937 8.02227 17.3794 8.23659C17.1651 8.45092 16.8744 8.57132 16.5713 8.57132Z"
											/>
										</svg>
									</span>
									<span className="form-options__text">
										{category.event_category_localized_name}
									</span>
								</label>
							</div>
						</li>
					))}

					<li key="clearAll">
						<hr />
					</li>
					<li key="clearAllLink">
						<a
							href="#"
							className="clear-all"
							onClick={(e) => {
								e.preventDefault();
								handleClearAll();
							}}
						>
							{messages.clearAll}
						</a>
					</li>
				</ul>
			</div>
		);
};

export default FilterDropdown;
